/*
 * @link https://www.humhub.org/
 * @copyright Copyright (c) 2017 HumHub GmbH & Co. KG
 * @license https://www.humhub.com/licences
 *
 */
import {schema} from './schema'

const hard_break = {
    id: 'hard_break',
    schema: schema
};

export default hard_break;
